import type { EncodedBoundaryResponse } from '@/src/lib/api';

export function hasUsableEncodedBoundary(
  encodedBoundary: string | Array<Array<string>> | null | undefined,
): encodedBoundary is string | Array<Array<string>> {
  if (typeof encodedBoundary === 'string') return encodedBoundary.length > 0;
  return encodedBoundary?.some((polygon) => polygon.some((ring) => ring.length > 0)) ?? false;
}

export function supportsAreaBoundary(areaType: string | undefined): boolean {
  return areaType !== 'university';
}

/** A null response is a failed fetch, so the boundary stays unknown rather than missing. */
export function isMissingBoundary(boundaryResponse: EncodedBoundaryResponse | null): boolean {
  return boundaryResponse != null && !hasUsableEncodedBoundary(boundaryResponse.boundary?.coordinates);
}

/** Point areas search the map box: no border, no toggle, no area detection, no scope clip. */
export function isPointArea(areaType: string | undefined, hasMissingBoundary: boolean): boolean {
  return !supportsAreaBoundary(areaType) || hasMissingBoundary;
}
